import { useRouter } from "next/router";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

export default function LanguageWrapper({ children }) {
	const router = useRouter();
	const { i18n } = useTranslation();

	const { language } = router.query;
	useEffect(() => {
		const supportedLanguageList = ["de", "en", "nl"];

		if (language && supportedLanguageList.includes(language)) {
			i18n.changeLanguage(language);
		}
	}, [language, i18n]);

	return children;
}
